'use client';

import Link from 'next/link';
import { useEffect } from 'react';
import { Globe, RefreshCw } from 'lucide-react';

export default function PublicProfileError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Public profile render error:', error);
  }, [error]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: '#f3f5f8',
      }}
    >
      <div
        style={{
          maxWidth: 460,
          width: '100%',
          background: '#ffffff',
          border: '1px solid rgba(0,0,0,0.07)',
          borderRadius: 16,
          padding: '32px 28px',
          textAlign: 'center',
          boxShadow: '0 1px 8px rgba(0,0,0,0.06), 0 4px 20px rgba(0,0,0,0.04)',
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            margin: '0 auto 18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(27,107,92,0.1)',
            color: '#1b6b5c',
          }}
        >
          <Globe size={26} />
        </div>
        <h1 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 800, color: '#0f1923' }}>
          This profile is unavailable
        </h1>
        <p style={{ margin: '0 0 22px', fontSize: 14, lineHeight: 1.6, color: '#5b6573' }}>
          We couldn&apos;t load this public profile right now. It may be private, moved, or
          temporarily unavailable. Please try again.
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => reset()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 18px',
              borderRadius: 10,
              border: 'none',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 700,
              color: '#ffffff',
              background: 'linear-gradient(135deg,#1b6b5c,#0d9488)',
            }}
          >
            <RefreshCw size={15} /> Try again
          </button>
          <Link
            href="/individual-dashboard/explore"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '10px 18px',
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.12)',
              fontSize: 14,
              fontWeight: 700,
              color: '#0f1923',
              textDecoration: 'none',
              background: '#fff',
            }}
          >
            Explore public records
          </Link>
        </div>
      </div>
    </div>
  );
}
